import { createAction } from 'redux-actions';

export const SET_SERVICES_IS_SAVING = 'SET_SERVICES_IS_SAVING';
export const SET_SERVICES_SAVED = 'SET_SERVICES_SAVED';

export const setServicesIsSaving = createAction(SET_SERVICES_IS_SAVING);
export const setServicesSaved = createAction(SET_SERVICES_SAVED);
